import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { AssessmentListComponent } from 'src/app/assessment/assessment-list/assessment-list.component';
import { AssessmentEditComponent } from './assessment-edit/assessment-edit.component';
import { AssessmentListService } from '../core/service/grid-data/grid-data-assessment.service';
import { AssessmentGridComponent } from './assessment-grid/assessment-grid.component';
import { FormlyCustomModule } from '../formly/formly.module';
import { AssessmentExportModule } from '../shared/assessment-export/assessment-export.module';
import { AssessmentTypeListComponent } from './assessment-type/assessment-type-list/assessment-type-list.component';
import { AssessmentTypeEditComponent } from './assessment-type/assessment-type-edit/assessment-type-edit.component';

@NgModule({
  imports: [
    SharedModule,
    FormlyCustomModule,
    AssessmentExportModule
  ],
  declarations: [
    AssessmentListComponent,
    AssessmentEditComponent,
    AssessmentGridComponent,
    AssessmentTypeListComponent,
    AssessmentTypeEditComponent
  ],
  providers: [
    AssessmentListService
  ]
})
export class AssessmentModule { }
